import Icon from '../components/Icon.vue'

Icon.register({"prescription-bottle-alt":{"width":384,"height":512,"paths":[{"d":"M360 0H24C10.8 0 0 10.8 0 24V72C0 85.2 10.8 96 24 96H360C373.2 96 384 85.2 384 72V24C384 10.8 373.2 0 360 0zM32 480C32 497.6 46.4 512 64 512H320C337.6 512 352 497.6 352 480V128H32V480zM96 296C96 291.6 99.6 288 104 288H160V232C160 227.6 163.6 224 168 224H216C220.4 224 224 227.6 224 232V288H280C284.4 288 288 291.6 288 296V344C288 348.4 284.4 352 280 352H224V408C224 412.4 220.4 416 216 416H168C163.6 416 160 412.4 160 408V352H104C99.6 352 96 348.4 96 344V296z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/prescription-bottle-alt.js
// module id = h4zp
// module chunks = 0